export default __webpack_public_path__ + "static/media/a6.1c1ec1a4.webp";